module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot101.e330bffc.jpg";